import { escapeHtml } from "../utils/escapeHtml";

interface ProgressData {
  validated: number;
  pending: number;
  overdue: number;
  totalBrands: number;
  totalDivisions: number;
}

export function renderProgressBar(container: HTMLElement, data: ProgressData): void {
  const total = data.validated + data.pending + data.overdue;
  const pct = total > 0 ? Math.round((data.validated / total) * 100) : 0;

  container.innerHTML = `
    <div class="validation-progress">
      <div class="validation-progress-header">
        <span class="validation-progress-title">Validation Progress</span>
        <span class="validation-progress-value">${data.validated} / ${total} projects (${pct}%)</span>
      </div>
      <div class="validation-progress-track">
        <div class="validation-progress-fill" style="width:${pct}%"></div>
      </div>
      <div class="validation-progress-legend">
        <span class="validation-progress-stat">🟢 ${data.validated} Validated</span>
        <span class="validation-progress-stat">🟡 ${data.pending} Pending</span>
        <span class="validation-progress-stat">🔴 ${data.overdue} Overdue</span>
        <span class="validation-progress-stat">📊 ${data.totalBrands} Brands · ${data.totalDivisions} Divisions</span>
      </div>
    </div>
  `;
}
